import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SupportButton from "@/components/base/SupportButton";
import PageMeta from "@/components/base/PageMeta";
import PricingSection from "@/pages/home/components/PricingSection";

export default function PreciosPage() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={darkMode ? "dark" : ""}>
      <PageMeta
        title="Precios | emite.do"
        description="Planes Esencial, Crecimiento y Avanzado para facturación electrónica e-CF certificada DGII. Odoo preconfigurado, firma P12 y soporte."
      />
      <div className={darkMode ? "bg-slate-950 text-white" : "bg-white text-slate-900"}>
        <Navbar darkMode={darkMode} onToggleDark={() => setDarkMode(!darkMode)} />
        <main className="pt-16">
          <PricingSection />
        </main>
        <Footer darkMode={darkMode} />
        <SupportButton />
      </div>
    </div>
  );
}
